import dynamic from 'next/dynamic'
import { Text } from '@emotion-icons/boxicons-regular/Text'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/text-widget.png'

const InsightText = dynamic(() => import('src/components/insight-text'), { ssr: false })
type RemoveType = Omit<InsightBuilderWidget, 'type'>
type TextOnlyWidget = RemoveType & { type: 'Text' }

export const InsightTextWidget: Readonly<TextOnlyWidget> = {
  id: 'insight-text',
  name: 'Text',
  type: 'Text',
  icon: Text,
  component: InsightText as any,
  preview,
  supportedResultTypes: [],
} as const
